// extracted by mini-css-extract-plugin
export default {"doctorImg":"DoctorProfile_doctorImg__fw5e2","specialty":"DoctorProfile_specialty__heWoy"};